import { fetchV3, fetchV3Payload } from "./client";

export const listServiceRequests = (filters, { useLoading = false } = {}) =>
  fetchV3({
    url: "electronic-medical-record/service-requests/",
    body: filters,
    useLoading,
  });

export const getServiceRequestFilters = (
  body,
  { useLoading = true } = {},
) =>
  fetchV3({
    url: "electronic-medical-record/service-requests/filters/",
    body: { ...body, statuses: body.checkbox },
    useLoading,
  });

export const createServiceRequestWithRelations = (payload) =>
  fetchV3({
    url: "service-requests/with_relations/",
    method: "POST",
    body: payload,
    skipErrorToast: true,
  });

export const createServiceRequest = (body, { useLoading = true } = {}) =>
  fetchV3({
    method: "POST",
    url: "service-requests/",
    body,
    useLoading,
  });

export const getServiceRequest = (uuid, { useLoading = true } = {}) =>
  fetchV3({
    url: `service-requests/${uuid}/`,
    useLoading,
  });

export const getCalendarEvents = (body, { useLoading = true } = {}) =>
  fetchV3({
    url: "service-requests/calendar/events/",
    body,
    useLoading,
  });

export const getCalendarGroupEvents = (uuid, { useLoading = true } = {}) =>
  fetchV3({
    url: `service-requests/calendar/group-events/${uuid}/`,
    useLoading,
  }).then(fetchV3Payload);

export const cancelServiceRequest = (uuid, reason) =>
  fetchV3({
    method: "PUT",
    url: `service-requests/cancel/${uuid}/`,
    body: { cancellation_reason: reason },
    useLoading: true,
  }).then(fetchV3Payload);

export const reactivateServiceRequest = (uuid) =>
  fetchV3({
    method: "PUT",
    url: `service-requests/reactivate/${uuid}/`,
    body: null,
    useLoading: true,
  }).then(fetchV3Payload);

export const declineOrReactivateAppointment = (uuid, reason, activate) =>
  activate
    ? reactivateServiceRequest(uuid)
    : cancelServiceRequest(uuid, reason);

export const completeServiceRequest = (uuid, files) =>
  fetchV3(
    {
      url: `doctors/service-requests/${uuid}/request-complete/`,
      method: "PUT",
      body: files,
      useLoading: true,
    },
    true,
  );

export const updateDoctorServiceRequest = (uuid, body) =>
  fetchV3({
    url: `doctors/service-requests/${uuid}/update/`,
    method: "PATCH",
    body,
    useLoading: true,
  });

export const updateRequestPatients = (uuid, body) =>
  fetchV3({
    method: "PATCH",
    url: `service-requests/update-request-patients/${uuid}/`,
    body,
    useLoading: true,
  });

export const updateRequestInfo = (uuid, body) =>
  fetchV3({
    method: "PATCH",
    url: `service-requests/update-request-info/${uuid}/`,
    body,
    useLoading: true,
  });

export const getPatientEmrDocuments = (id) =>
  fetchV3({
    url: `patients/emr-documents/${id}/`,
    method: "GET",
    useLoading: true,
  });
